<template>
    <div class="card">
        <div class="card-header">Ausgeblendete Artikel</div>
        <div class="card-body">
            <SmartButton
                variant="primary"
                :disabled="selectedArticles.length === 0"
                @click="addToBlacklist"
            >
                abgewählte Artikel ausblenden ({{ selectedArticles.length }})
            </SmartButton>
            <Info>
                Entfernt die abgewählten Artikel permanent aus der Tabelle. Eine Liste aller
                ausgeblendeten Artikel gibt es
                <router-link to="/blacklist">hier.</router-link>
                Die Artikel können von dort auch wieder eingeblendet werden.
            </Info>
        </div>
    </div>
</template>

<script>
import SmartButton from "@/views/shared/widgets/SmartButton";
import Info from "@/components/widgets/Info";
export default {
    name: "Blacklist",
    components: { Info, SmartButton },
    props: {
        value: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    computed: {
        selectedArticles() {
            return this.$store.state.data.currentTabData
                .filter(article => article.selected)
                .map(article => article.pzn);
        }
    },
    methods: {
        async addToBlacklist() {
            await this.$store.dispatch("addToBlacklist", this.selectedArticles);
            await this.$store.dispatch("loadArticles");
            await this.$store.dispatch("calculateAndFilterTabData");
            this.$store.state.data.currentTabData.forEach(article => (article.selected = false));
        }
    }
};
</script>

<style scoped>
.card-body > * {
    margin: 2px;
}

.card-body {
    display: flex;
    flex-direction: column;
}
</style>
